/* eslint-disable react/no-danger */
import axios from 'axios/index';
import PropTypes from 'prop-types';
import React from 'react';
import CompanyPageLayout from '../../../components/CompanyPages/CompanyPageLayout/CompanyPageLayout';
import ArticleGrid from '../../../components/CompanyPages/Sections/ArticleGrid/ArticleGrid';
import EmployerPageJobCallToAction from '../../../components/CompanyPages/Sections/EmployerPageJobCallToAction/EmployerPageJobCallToAction';
import PopUp from '../../../components/Elements/PopUp/PopUp';
import { JobContextProvider } from '../../../contexts/JobContext';
import BenefitsContentSection from '../../../components/Employer/Benefits/BenefitsContentSection/BenefitsContentSection';
import IndustryTable from '../../../components/Employer/Benefits/IndustryTable/IndustryTable';
import MobileIndustrialTable from '../../../components/Employer/Benefits/MobileIndustrialTable/MobileIndustrialTable';
import {
    COMPANY_PROPTYPES,
    DEFAULT_COMPANY_PROPS,
} from '../../../components/Includes/CompanyProps';
import { relatedArticlesProps } from '../../../components/Includes/relatedArticlesProps';
import ControlledWidthContainerEightHundred from '../../../components/Layout/ControlledWidthContainerEightHundred/ControlledWidthContainerEightHundred';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
    PAGE_TABS,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';
import { PAGE_PROPS } from '../../defaultProps';
import {
    employerHeaderDefaultProps,
    employerHeaderProps,
} from '../employerHeaderProps';

import './EmployerBenefits.scss';

export default class EmployerBenefits extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showSubmitCommentConfirmation: false,
        };
    }

    closeSubmitCommentConfirmation = () => {
        this.setState({ showSubmitCommentConfirmation: false });
    };

    onCommentSubmit = (fieldName, tip, comment) => {
        return (
            axios
                .post(this.props.submitUrl, {
                    inputName: fieldName,
                    companyId: this.props.company.companyId,
                    tip,
                    comment,
                })
                .then(() => {
                    this.setState({ showSubmitCommentConfirmation: true });
                })
                // eslint-disable-next-line no-console
                .catch(console.error)
        );
    };

    renderDescription = (record) => {
        if (!record) return;

        return (
            <div className="row">
                <div className="left-col">{record.title}</div>
                <div
                    className="right-col"
                    dangerouslySetInnerHTML={{ __html: record.detail }}
                />
            </div>
        );
    };

    renderSubBenefits = (records) => {
        if (!records) return;

        return (
            <React.Fragment>
                {records.map((record) => {
                    return (
                        <div className="row" key={record.type}>
                            <div className="left-col">{record.title}</div>
                            <div
                                className="right-col inline-p"
                                dangerouslySetInnerHTML={{
                                    __html: record.description,
                                }}
                            />
                        </div>
                    );
                })}
            </React.Fragment>
        );
    };

    renderPercentage = (record) => {
        if (!record) return;

        return (
            <div className="row">
                <div className="left-col">
                    Percentage of your workforce that takes advantage of
                    flexible working
                </div>
                <div className="right-col">{record}%</div>
            </div>
        );
    };

    renderVerifiedPartnerData = () => {
        return (
            <div className="component-CompanyPages-Sections-VerifiedPartnerData">
                <div className="section-title">Benefits & Family Policies</div>
                <div className="eyebrow">Verified Partner Data</div>
                {this.props.verifiedPartnerData.map((record) => {
                    const sectionStyle =
                        record.description.detail ||
                        record.percentage ||
                        record.subBenefits.length > 0
                            ? { display: 'block' }
                            : { display: 'none' };

                    return (
                        <section style={sectionStyle} key={record.benefitGroup}>
                            <div className="section-header">
                                {record.benefitGroup}
                            </div>
                            {record.description && record.description.detail
                                ? this.renderDescription(record.description)
                                : null}
                            {this.renderPercentage(record.percentage)}
                            {this.renderSubBenefits(record.subBenefits)}
                        </section>
                    );
                })}
            </div>
        );
    };

    renderBenefitsContentSection = () => {
        const props = {
            industry: this.props.industry,
            company: this.props.company,
            benefitsUrl: this.props.benefitsUrl,
            onCommentSubmit: this.onCommentSubmit,
            bestCompaniesBadges: this.props.bestCompaniesBadges,
            companyRating: this.props.companyRating,
            companyRecords: this.props.companyRecords,
            relatedArticles: this.props.relatedArticles,
            industryRecords: this.props.industryRecords,
            companyId: this.props.company.companyId,
            submitUrl: this.props.submitUrl,
        };
        return (
            <div className="position-relative">
                <BenefitsContentSection {...props} />
            </div>
        );
    };

    renderPopUp = () => {
        return (
            <PopUp
                buttonText="Continue"
                showPopUp={this.state.showSubmitCommentConfirmation}
                // eslint-disable-next-line react/no-children-prop
                children={
                    <p style={{ width: '320px' }}>
                        Thanks for the tip! We&apos;ll review and post content
                        that meets guidelines shortly.
                    </p>
                }
                showLogo
                close={this.closeSubmitCommentConfirmation}
                showOverlay
            />
        );
    };

    renderMobileIndustrialTable = () => {
        return (
            <MobileIndustrialTable
                theads={['Benefits', 'Median', 'Average']}
                rowRecords={this.props.industryRecords}
            />
        );
    };

    renderResponsiveIndustrialRecords = () => {
        return (
            <div>
                <div className="d-none d-md-block">
                    <IndustryTable
                        theads={['Benefits', 'Median', 'Average']}
                        rowRecords={this.props.industryRecords}
                    />
                </div>

                <div className="d-block d-md-none">
                    {this.renderMobileIndustrialTable()}
                </div>
            </div>
        );
    };

    renderIndustrialTable = () => {
        return (
            <div className="component-Employer-Benefits-IndustrySection">
                <div className="section-title">
                    What should you expect in this industry?
                </div>
                <div className="section-header">
                     {this.props.industry}
                </div>
                <div className="section-description">
                    What benefits do employers in the {' '}
                    {this.props.industry} industry offer?
                </div>
                {this.renderResponsiveIndustrialRecords()}
            </div>
        );
    };

    renderCompanyArticlesSection = () => {
        const articles = this.props.companyArticles;

        const title = `Read more about ${this.props.company.companyName}`;
        return articles && articles.length ? (
            <ArticleGrid content={articles} title={title} />
        ) : null;
    };

    renderEmployerJobCallToAction = () => {
        if (this.props.company.employerInfo.jobCount === 0) {
            return;
        }

        const props = {
            title: `${this.props.company.companyName} is hiring`,
            description: this.props.bannerText,
            jobCount: this.props.company.employerInfo.jobCount,
            button: {
                url: `/company/jobs/${this.props.company.companyUrl}`,
                text: `See all jobs`,
            },
        };
        return (
            <ControlledWidthContainerEightHundred>
                <EmployerPageJobCallToAction {...props} />
            </ControlledWidthContainerEightHundred>
        );
    };

    displaySponsoredContent = () => {
        return [
            <React.Fragment key="0">
                {this.renderVerifiedPartnerData()}
            </React.Fragment>,
            <React.Fragment key="1">
                {this.renderBenefitsContentSection()}
                {this.renderPopUp()}
            </React.Fragment>,
            <React.Fragment key="2">
                {this.renderIndustrialTable()}
                {this.renderCompanyArticlesSection()}
                {this.renderEmployerJobCallToAction()}
            </React.Fragment>,
        ];
    };

    displayNonSponsoredContent = () => {
        return [
            <React.Fragment key="0">
                {this.renderBenefitsContentSection()}
                {this.renderPopUp()}
            </React.Fragment>,
            <React.Fragment key="1">
                {this.renderIndustrialTable()}
            </React.Fragment>,
        ];
    };

    render() {
        return (
            <div className="page-Employer-EmployerBenefits">
                <SnowplowPageViewTracker
                    pageCompanyId={this.props.company.companyId}
                    pageEntityId={this.props.company.companyId}
                    pageSection={PAGE_VIEW_SECTIONS.COMPANY_PROFILE}
                    pageTab={PAGE_TABS.COMPANY_BENEFITS}
                    pageType={PAGE_VIEW_TYPES.CONTENT}
                />
                <JobContextProvider
                    content={[]}
                    userJobProfile={this.props.userJobProfile}
                >
                    <CompanyPageLayout
                        topics={this.props.topics}
                        company={this.props.company}
                    >
                        {this.props.company.isSponsor
                            ? this.displaySponsoredContent()
                            : this.displayNonSponsoredContent()}
                    </CompanyPageLayout>
                </JobContextProvider>
            </div>
        );
    }
}

EmployerBenefits.propTypes = {
    /**
     * Global props from the server
     */
    PAGE_PROPS,
    bannerText: PropTypes.string,
    /**
     * topics
     */
    topics: PropTypes.arrayOf(PropTypes.shape()),
    /**
     * props for employer Header
     */
    employerHeaderProps,
    /**
     * industry that company belongs to
     */
    company: PropTypes.shape(COMPANY_PROPTYPES),
    industry: PropTypes.string,
    /*
     * url of benefit definition page
     */
    benefitsUrl: PropTypes.string.isRequired,
    /**
     * url endpoint for submitting comments/tips
     */
    submitUrl: PropTypes.string.isRequired,
    /**
     * best company badges
     */
    bestCompaniesBadges: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            url: PropTypes.string,
        })
    ),
    /**
     * company rating
     */
    companyRating: PropTypes.number.isRequired,
    /**
     * array of company records
     */
    companyRecords: PropTypes.arrayOf(
        PropTypes.shape({
            /**
             * what type of benefits
             */
            fieldName: PropTypes.string.isRequired,
            /**
             * lowest record
             */
            low: PropTypes.string,
            /**
             * median record
             */
            median: PropTypes.string,
            /**
             * highest record
             */
            high: PropTypes.string,
            /**
             * array of benefit comments
             */
            comments: PropTypes.arrayOf(PropTypes.shape()),
            /**
             * type of policy
             */
            type: PropTypes.string,
            /**
             * description of the data, to be displayed on tooltip
             */
            description: PropTypes.string,
            /**
             * tip input type
             */
            tipInputType: PropTypes.oneOf(['dropdown', 'inputBox']),
        })
    ).isRequired,
    /**
     * industrial records
     */
    industryRecords: PropTypes.arrayOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                data: PropTypes.string,
                description: PropTypes.string,
            })
        )
    ).isRequired,
    companyArticles: PropTypes.arrayOf(
        PropTypes.shape({
            contentUrl: PropTypes.string,
            title: PropTypes.string,
            contentImage: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.string,
            }),
            description: PropTypes.string,
        })
    ),
    relatedArticles: relatedArticlesProps,
    userJobProfile: PropTypes.shape(),
    verifiedPartnerData: PropTypes.arrayOf(
        PropTypes.shape({
            benefitGroup: PropTypes.string,
            description: PropTypes.shape({
                type: PropTypes.string,
                description: PropTypes.string, // string
            }), // html string
            percentage: PropTypes.number, // null if doesn't have it
            subBenefits: PropTypes.arrayOf(
                PropTypes.shape({
                    type: PropTypes.string,
                    description: PropTypes.string, // string
                })
            ),
        })
    ), // null if not sponsor,
};

EmployerBenefits.defaultProps = {
    /**
     * Global props from the server
     */
    PAGE_PROPS: { url: { path: '/' } },
    bannerText: '',
    bestCompaniesBadges: [],
    company: DEFAULT_COMPANY_PROPS,
    companyArticles: [],
    employerHeaderProps: employerHeaderDefaultProps,
    industry: '',
    relatedArticles: [],
    topics: [],
    userJobProfile: null,
    verifiedPartnerData: null,
};
